import * as React from "react";
import "./NavBar.css";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { State } from "../../reducers/index";
import { disconnect } from "../../actions/user.actions";
import DesktopTopNavBar from "../../components/NavBar/DesktopNavBar/DesktopTopNavBar";
import  MobileSideNavBar from "../../components/NavBar/MobileSideNavBar/MobileSideNavBar";
import { NavBarState } from "../../reducers/navBar.reducer";
import { useResponsive } from "../../utils/useResponsive";

interface NavBarProps {
    navBar: NavBarState;
    dispatch: Dispatch<any>;
}

const mapStatetoProps = (state: State) => {
    return {
        navBar: state.navBar
    };
};

const NavBarComponent: React.FC<NavBarProps> = ({ dispatch, navBar }) => {
    const { isMobile, isDesktop } = useResponsive();

    const handleLogOut = () => {
        dispatch(disconnect());
    };

    return (
        <React.Fragment>
            {isDesktop && (
                <div className={`NavBarVisible${String(navBar.visibility)}`}>
                    <DesktopTopNavBar handleLogOut={handleLogOut} />
                </div>
            )}

            {isMobile && (
                <div className={`NavBarVisible${String(navBar.visibility)} mobile`}>
                    <MobileSideNavBar
                        handleLogOut={handleLogOut}
                        showSideNavBar={navBar.showSideBar}
                    />
                </div>
            )}
        </React.Fragment>
    );
};

export default connect(mapStatetoProps)(NavBarComponent);